import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ProductCard from "@/components/ProductCard";
import { OctopusMascot } from "@/components/Mascot";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export default function FavoritesPage() {
  const { favorites, addToCart } = useStore();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products")
      .then(({ data }) => setProducts(data.filter((p) => favorites.includes(p.id))))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [favorites]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <h1 className="text-3xl sm:text-4xl font-black text-slate-900 mb-8" data-testid="favorites-title">
          💗 Meus favoritos
        </h1>
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="rounded-2xl bg-slate-100 aspect-[3/4] animate-pulse" />
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="flex flex-col items-center text-center py-20 gap-4" data-testid="favorites-empty-state">
            <OctopusMascot size={110} className="animate-float-slower" />
            <div>
              <p className="font-bold text-slate-800 text-lg">Nenhum favorito ainda</p>
              <p className="text-sm text-slate-500 mt-1">Toque no coração dos produtos que você amar.</p>
            </div>
            <a href="/produtos" className="bg-brand-gradient text-white font-bold px-6 py-3 rounded-full text-sm shadow-soft active:scale-95 transition-transform" data-testid="favorites-empty-cta">
              Explorar produtos
            </a>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} onAdd={(prod) => addToCart(prod, 1)} />
            ))}
          </div>
        )}
      </main>
      <Footer />
      <CartDrawer />
      <WhatsAppFloat />
    </div>
  );
}
